export interface IBankingInformation {
  bankingName: String
  bankingAccountNumber: String
  bankingBranch: String
  accountHolderName: String
}
const rulesBanking = {
  bankingName: 'required',
  bankingAccountNumber: 'required',
  bankingBranch: 'required',
  accountHolderName: 'required'
}

const initBanking = {
  bankingName: '',
  bankingAccountNumber: '',
  bankingBranch: '',
  accountHolderName: ''
}

export default {
  rulesBanking,
  initBanking
}
